module.exports = __webpack_public_path__ + "media/bootstrap-icons/graph-up-5fa409c2.svg";